module.exports = __webpack_public_path__ + "img/79.3a60b557.jpg";